import { Grid, Typography } from "@mui/material";
import Form from "components/UI/Form";
import MuiButton from "components/UI/MuiButton";
import { InputTypes } from "constants/enums";
import { IFormField } from "models/app";
import React from "react";
import * as Yup from "yup";

interface Props {
  onChange: (name: string, value: any) => void;
  onSubmit: () => void;
  showCode?: boolean;
}

const LoginForm: React.FC<Props> = ({ onChange, onSubmit, showCode }) => {

  const basicFields1: IFormField[] = [
    {
      name: "CountryCode",
      label: "Country Code",
      type: InputTypes.COUNTRY,
      defaultValue: '+966',
    }
  ];

  const basicFields2: IFormField[] = [

    {
      name: "phoneNumber",
      label: "Phone Number",
      type: InputTypes.TEXT,
      placeholder: "Phone Number",
    },

  ];

  const basicFields3: IFormField[] = [
    {
      name: "code",
      label: "Code",
      type: InputTypes.TEXT,
      placeholder: "Code",
    },
  ];



  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
      onSubmit();
    }
  };

  return (
    <div onKeyDown={handleKeyDown}>
      {showCode ?
        <Form
          fields={basicFields3}
          onChange={onChange}
          cb={onSubmit}
          buttonText={"Login"}
        />





        :
        <div>
          <div style={{ display: 'flex', alignItems: 'end' }}>
            <div style={{ width: '35%' }}>
              <Form
                fields={basicFields1}
                onChange={onChange}
              />
            </div>

            <div style={{ width: '65%' }}>
              <Form
                fields={basicFields2}
                onChange={onChange}
              />
            </div>
          </div>
          <Typography
            variant="subtitle2"
            style={{ marginBlock: "5px", textAlign: 'center' }}
          >
            Use your credentials to access your account.
          </Typography>
          <Grid container justifyContent="center" sx={{ py: 2 }}>
            <MuiButton
              size="large"
              variant="contained"
              type="submit"
              sx={{ minWidth: 184 }}
              onClick={(onSubmit)}
            >
              Login
            </MuiButton>
          </Grid>

        </div>


      }
    </div>

  );
};

export default LoginForm;
